import { AfterViewInit, ApplicationRef, Component, ComponentRef, EnvironmentInjector, Inject, Injector, OnDestroy, OnInit, Optional, SecurityContext, ViewChild, createComponent, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from 'src/app/services/common.service';
import { DateFormatService } from 'src/app/services/dateFormat.service';
import { DeleteDialog } from 'src/app/shared/delete-dialog/delete-dialog.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'src/app/services/toast.service';
import nameOf from 'src/app/shared/form/nameOf.helper';
import { translateEnum } from 'src/app/_helpers/translate-enum.helper';
import { SampleService } from 'src/app/services/sample.service';
import { Sample } from 'src/app/models/sample.model';
import { SampleStatusColors, SampleStatusTextColors, SampleStatusEnum, SampleEditableFields, getFilteredSampleStatuses, isSampleStatusSelectable, getStatusBadgeClass, isLockedSampleStatus } from 'src/app/enums/sampleStatus.enum';
import { getEnumLookup } from 'src/app/_helpers/enum-helper';
import { BatchActionMenuItem } from 'src/app/models/batchAction.model';
import { MonitoringReasonTypeEnum } from 'src/app/enums/monitoringReasonType.enum';
import { ValueConversionService } from 'src/app/services/value-conversion.service';
import { SampleCensorSign, SampleCensorType } from 'src/app/enums/sampleCensorType.enum';
import { CoreGridComponent, ExportMenuOption } from 'src/app/shared/grid/core-grid/core-grid.component';
import { PermissionFlags } from 'src/app/enums/permissionFlags.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { EvidencePackRequest } from 'src/app/models/evidencePackRequest.model';
import { EvidencePackDialogComponent, EvidencePackComponentOption, EvidencePackComponentFlags } from 'src/app/modals/evidence-pack-dialog/evidence-pack-dialog.component';
import { ChildColumnConfig, ColumnConfig } from 'src/app/shared/grid/core-grid/columnConfig.model';
import { AuthService } from 'src/app/services';
import { catchError, firstValueFrom, forkJoin, map, Observable, of, Subscription, switchMap } from 'rxjs';
import { RolePermissionObjects } from 'src/app/shared/constants/rolePermissionObjects.constants';
import { IFormDialogData } from 'src/app/shared/form/form.component';
import { FlyoutContainerComponent } from 'src/app/shared/flyout/flyout-container/flyout-container.component';
import { EventService } from 'src/app/services/event.service';
import { EventKeys } from 'src/app/shared/constants/eventKeys.constants';
import { GridViewService } from 'src/app/services/grid-view.service';
import { getNamedEnum } from 'src/app/_helpers/enum-helper';
import { GridSettingsService } from 'src/app/shared/grid/core-grid/grid-settings-flyout/grid-settings.service';
import { SampleTypeEnum } from 'src/app/enums/sampleType.enum';
import { SampleCategoryEnum } from 'src/app/enums/sampleCategory.enum';
import { ExposureTypicality } from 'src/app/enums/exposureTypicality.enum';
import { WeatherConditionType } from 'src/app/enums/weatherConditionType.enum';
import { UnsampledTimeCorrectionType } from 'src/app/enums/unsampledTimeCorrectionType.enum';
import { SegService } from 'src/app/services/seg.service';
import { SampleSurveyService } from 'src/app/services/sample-survey.service';
import { AgentService } from 'src/app/services/agent.service';
import { IhLabResultService } from 'src/app/services/IH-lab-result.service';
import { IhLabResult } from 'src/app/models/IhLabResult.model';
import { ALL_UNITS_ENUM_FILTER_MAP } from 'src/app/services/unit-filter.service';
import { OelTypeService } from 'src/app/services/oel-type.service';
import { JurisdictionService } from 'src/app/services/jurisdiction.service';
import { AgentGroupService } from 'src/app/services/agentGroup.service';
import { OrganizationLevelService } from 'src/app/services/organizationLevel.service';
import { AnalyticalMethodService } from 'src/app/services/analytical-method.service';
import { SampleMediaService } from 'src/app/services/sample-media.service';
import { sampleRouteConfig } from 'src/app/shared/constants/sampleRouteConfig.constants';
import { GenerateCocPopupComponent, IGenerateCocPopup } from 'src/app/common-components/generate-coc-popup/generate-coc-popup.component';
import { SampleShiftCoverage } from 'src/app/enums/sampleShiftType.enum';
import { ShiftType } from 'src/app/enums/shiftTypeValue.enum';
import { Units, UnitSymbols } from 'src/app/enums/units.enum';
import { SampleDialogComponent } from 'src/app/modals/sample-dialog/sample-dialog.component';
import { ConfirmLeaveDialogComponent, ConfirmLeaveResult } from 'src/app/modals/confirm-leave-dialog/confirm-leave-dialog.component';
import { ParameterTypeEnum } from 'src/app/enums/parameterType.enum';
import { ParameterUnitService } from 'src/app/services/parameter-unit.service';
import { TranslateService } from 'src/app/services/translate.service';
import { ISearchFieldData, WIDGET_CONFIG, DATE_FILTER_TYPE_ENUM, ADDITIONAL_FILTERS_QUERY_PARAM } from 'src/app/shared/grid/baseGrid.component';
import { canonicalizeDrillDownFilterKeys, parseDrillDownFilters } from 'src/app/shared/utils/drill-down-filter-keys.util';
import { ICrudService } from 'src/app/shared/grid/crud.service';
import { WidgetConfig } from 'src/app/models/dashboard';
import { BatchAction } from 'src/app/models/batchAction.model';
import { BulkDeleteConfirmationDialogComponent, BulkDeleteDialogData } from 'src/app/modals/bulk-delete-confirmation-dialog/bulk-delete-confirmation-dialog.component';
import { VoidReasonDialogComponent, IVoidReasonResult } from 'src/app/modals/void-reason-dialog/void-reason-dialog.component';
import { BulkEditSamplesDialogComponent } from 'src/app/modals/bulk-edit-samples-dialog/bulk-edit-samples-dialog.component';
import { ReportGenerationPopupComponent } from 'src/app/components/report-generation-popup/report-generation-popup.component';
import { PdfGeneratedData } from 'src/app/models/pdfGeneratedData.model';
import { ReportGenerationService } from 'src/app/services/report-generation.service';
import { ENTITY_TYPES } from 'src/app/shared/widget-registry';
import { findLowestCommonAncestor, OrgLevelNode } from 'src/app/shared/helpers/org-level-lca.helper';
import { escapeHtml } from 'src/app/shared/helpers/html-escape.helper';
import { ALL_EXCEEDING_LAB_RESULTS_FILTER, EXCEEDING_LAB_RESULT_FILTER_KEY } from 'src/app/models/exceedance-compliance.model';
import { QuickFilter } from 'src/app/models/columnFilter.model';
import { SAMPLE_FILTER_KEYS } from 'src/app/components/dashboard/dashboard-widgets/exceedance-compliance-widget/exceedance-compliance-widget.constants';
import { ColumnDetails } from 'src/app/models/columnDetails.model';
import { buildSampleEndPointColumn, isSampleEndPointColumn, toEndPointColumnType } from 'src/app/shared/helpers/sample-endpoint-columns.helper';
import { TenantRiskService } from 'src/app/services/tenantRisk.service';
import { findCalDriftBreaches } from 'src/app/shared/utils/cal-drift.util';
import { BulkCalDriftWarningDialogComponent } from 'src/app/modals/bulk-cal-drift-warning-dialog/bulk-cal-drift-warning-dialog.component';
import { CalDriftBreach, IBulkCalDriftWarningData } from 'src/app/models/calDriftBreach.model';

@Component({
  standalone: false,
    selector: 'app-sample-list',
    templateUrl: './../../shared/grid/core-grid/core-grid.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./../../shared/grid/core-grid/core-grid.component.scss', './sample-list.component.scss'],
})
export class SampleListComponent extends CoreGridComponent<Sample> implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(FlyoutContainerComponent) flyout!: FlyoutContainerComponent;

    protected override get enableCheckboxSelection(): boolean { return true; }

    protected override anchorColumns: string[] = [nameOf<Sample>(x => x.sampleNumber)];
    protected override drillDownFilterLabels: Record<string, string> = {
        [SAMPLE_FILTER_KEYS.surveyTypeId]: 'Only selected survey types',
    };
    protected override quickFilters: QuickFilter[] = [{
        key: EXCEEDING_LAB_RESULT_FILTER_KEY,
        label: 'Only exceedances',
        description: 'Lab results above their OEL',
        value: JSON.stringify(ALL_EXCEEDING_LAB_RESULTS_FILTER),
    }];

    dateFormat = "";
    showSampleForm: boolean = false;
    triggerPopulateSampleForm: boolean = false;
    showGroupAssignment: number = -1;
    editSampleGroupId: number = 0;
    editSampleGroupName: string = "";
    editSampleGroup: boolean = false;
    itemsPerPage = 10;
    currentPage = 1;
    sampleStatusEnum = getNamedEnum(SampleStatusEnum);
    monitoringReasonTypeEnum = getNamedEnum(MonitoringReasonTypeEnum);
    isCocPopup: boolean;
    private multiSampleReportPopupRef?: ComponentRef<ReportGenerationPopupComponent>;
    private multiSamplePopupSubs: Subscription[] = [];
    private static readonly REPORT_ALLOWED_STATUSES: readonly SampleStatusEnum[] = [
        SampleStatusEnum.Approved,
        SampleStatusEnum.ApprovedLetterSent
    ];

    constructor(
        private sampleService: SampleService,
        private dateFormatService: DateFormatService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        protected toastService: ToastService,
        protected dialog: MatDialog,
        protected commonService: CommonService,
        protected valueConversionService: ValueConversionService,
        private eventService: EventService,
        authService: AuthService,
        gridViewService: GridViewService,
        gridSettingsService: GridSettingsService,
        private segService: SegService,
        private sampleSurveyService: SampleSurveyService,
        private agentService: AgentService,
        private ihLabResultService: IhLabResultService,
        private oelTypeService: OelTypeService,
        private jurisdictionService: JurisdictionService,
        private agentGroupService: AgentGroupService,
        private organizationLevelService: OrganizationLevelService,
        private sampleMediaService: SampleMediaService,
        private analyticalMethodService: AnalyticalMethodService,
        private parameterUnitService: ParameterUnitService,
        private translateService: TranslateService,
        private readonly sanitizer: DomSanitizer,
        private reportGenerationService: ReportGenerationService,
        private appRef: ApplicationRef,
        private environmentInjector: EnvironmentInjector,
        private tenantRiskService: TenantRiskService,
        protected injector: Injector,
        @Optional() @Inject(MAT_DIALOG_DATA) public searchFieldData: ISearchFieldData,
        @Optional() @Inject(WIDGET_CONFIG) widgetConfig?: WidgetConfig
    ) {
        super(toastService, dialog, commonService, authService, gridViewService, gridSettingsService, widgetConfig);
        this.gridService = sampleService;
    }

    ngOnInit(): void {
        this.searchDialogRef = this.injector.get(MatDialogRef<SampleListComponent>, null);
        const dialogFilters = this.searchFieldData?.additionalFilters;
        if (dialogFilters && typeof dialogFilters === 'object') {
            this.additionalFilters = {
                ...this.additionalFilters,
                ...(dialogFilters as Record<string, string | number | boolean>)
            };
        }

        const filters = parseDrillDownFilters(this.activatedRoute.snapshot.queryParamMap.get(ADDITIONAL_FILTERS_QUERY_PARAM));
        if (filters) {
            this.additionalFilters = canonicalizeDrillDownFilterKeys(filters, [
                this.orgFilterKey,
                this.parameterFilterKey,
                DATE_FILTER_TYPE_ENUM,
                EXCEEDING_LAB_RESULT_FILTER_KEY,
            ]);
            if (this.additionalFilters[DATE_FILTER_TYPE_ENUM]) {
                this.anchorColumns = [...this.anchorColumns, nameOf<Sample>(x => x.startDate)];
            }
        }
        super.ngOnInit();
        this.dateFormat = this.dateFormatService.userDateWithTimeFormat;
        this.setAdditionalButton();
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.loadHeaderData();
        this.eventService.on<Sample | boolean>(EventKeys.flyoutClose).subscribe((event) => {
            if (event) this.closeFlyout(event);
            else this.closeFlyoutInternal();
        })
        if (this.flyout) {
            this.flyout.close = () => { this.openConfirmLeaveDialog() }
        }
    }

    openConfirmLeaveDialog() {
        const dialogRef = this.dialog.open(ConfirmLeaveDialogComponent, {
            width: '400px'
        });

        dialogRef.afterClosed().subscribe(result => {
            this.closeFlyout(result === ConfirmLeaveResult.Discard);
        });
    }

    closeFlyout(data: Sample | boolean) {
        if (data) {
            if (typeof data !== 'boolean') {
                if (this.isCocPopup) {
                    this.openLabRequisition();
                    this.isCocPopup = false;
                } else {
                    if (data.sampleNumber) this.toastService.showSuccess(`Sample Number - {{sampleNumber}} has been created/updated Successfully`, true, { sampleNumber: data.sampleNumber });
                    this.openSampleDetail(data);
                }
            }
            this.eventService.broadcast(EventKeys.blockOutsideCLick, false);
            this.isFlyoutOpen = false;
            this.flyout.container.clear();
            this.flyout.isOpen = false;
        }
    }

    protected get objectId(): string {
        return RolePermissionObjects.Sample;
    }

    protected get isGridViewEnabled(): boolean {
        return true;
    }

    get hasOrgFilter() {
        return true;
    }

    override initializeColumns(): void {
        this.additionalActions = [];

        const buildLabResultsColumn = (
            name: string,
            displayName: string,
            mapper: (sample: Sample, result: IhLabResult) => string,
            extraCssClass: string = ''
        ): ColumnConfig<Sample> => {
            return new ColumnConfig<Sample>({
                name, displayName,
                cellTemplate: (sample) => {
                    if (!sample.ihLabResults?.length) return ' - '; return sample.ihLabResults.map(result => `<div>${mapper(sample, result) ?? '-'}</div>`).join('');
                },
                cssClass: (sample) =>
                    sample.ihLabResults?.length ? `multiple-data-border ${extraCssClass}`.trim() : '',
                applyNestedFiltering: true,
            });
        };
        const getTemp = (value) => value ? this.valueConversionService.getParameterValueFromUserPreferences(value, ParameterTypeEnum.Temperature).toFixed(1) + this.valueConversionService.getTemperatureUnit() : '-';


        this.columnConfigs = [
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.sampleNumber),
                displayName: 'Sample Number',
                onClick: (sample) => this.openSampleDetail(sample),
                cssClass: () => 'cursor-pointer',
                tooltip: (sample) => `Click to view details for ${sample.sampleNumber}`
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.alternateSampleNumber),
                displayName: 'Alternate Sample Number',
                cssClass: () => 'cursor-pointer',
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.sampleStatus),
                displayName: 'Sample Status',
                cssClass: () => 'extended-status-column',
                cellTemplate: () => '',
                enumFilterMap: this.enumToValueNameArray(SampleStatusEnum)
                    .filter(s => s.value !== SampleStatusEnum.Planned)
                    .map(s => s.value === SampleStatusEnum.AwaitingLabSubmission
                        ? { ...s, name: 'Awaiting Lab Submission / Awaiting Results' } : s),
                children: (row) => {
                    const badgeClass = this.getSampleStatusBadgeClass(row.sampleStatus);
                    return [
                        new ChildColumnConfig<Sample>({
                            cellTemplate: () => this.getSampleStatusDisplayName(row),
                            cssClass: () => `status-badge ${badgeClass}`
                        })
                    ];
                }
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.sampleType),
                displayName: 'Sample Type',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => translateEnum(SampleTypeEnum, sample.sampleType, this.translateService),
                enumFilterMap: this.enumToValueNameArray(SampleTypeEnum)
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.sampleCategory),
                displayName: 'Sample Category',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => this.translateService.getDynamicTranslation(SampleCategoryEnum[sample.sampleCategory] || ' - '),
                enumFilterMap: this.enumToValueNameArray(SampleCategoryEnum)
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.startDate),
                displayName: 'Start Date',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => this.dateFormatService.formatUtcTimestampToUserTimezone(
                    sample.startDate as number, this.dateFormat)
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.endDate),
                displayName: 'End Date',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => this.dateFormatService.formatUtcTimestampToUserTimezone(
                    sample.endDate as number, this.dateFormat)
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.sampleDuration),
                displayName: 'Sample Duration',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => parseFloat((sample.sampleDuration / 60).toFixed(2)) + ' min(s)',
                valueOutputTransformRule: (value: number) => value * 60,
                valueInputTransformRule: (value: number) => value / 60
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.shiftLength),
                displayName: 'Shift Length',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => {
                    const shiftLength = sample?.shiftLength;
                    if (shiftLength === null || shiftLength === undefined || Number.isNaN(shiftLength)) return 'N/A';
                    const minutes = this.valueConversionService.convertSecondsToMinutes(shiftLength);
                    if (minutes < 0) return 'Invalid';
                    return `${minutes} min(s)`;
                },
                valueOutputTransformRule: (value: number) => value * 60,
                valueInputTransformRule: (value: number) => value / 60
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.shiftType),
                displayName: 'Shift Type',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => translateEnum(SampleShiftCoverage, sample.shiftType, this.translateService),
                enumFilterMap: this.enumToValueNameArray(SampleShiftCoverage)
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.shiftRoster),
                displayName: 'Shift Roster',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => translateEnum(ShiftType, sample.shiftRoster, this.translateService, name => name.replace(/_/g, ' ')),
                enumFilterMap: this.enumToValueNameArray(ShiftType)
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.sampleSurveyId),
                displayName: 'Survey Name',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => sample.surveyName ?? ' - '
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.segId),
                displayName: 'SEG Name',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => sample.segName ?? ' - '
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.segCode),
                displayName: 'SEG Code',
                cssClass: () => 'cursor-pointer',
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.organizationLevelId),
                displayName: 'Organization Level',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => sample.organizationLevelName
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.organizationLevelCode),
                displayName: 'Organization Code',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => sample.organizationLevelCode ?? '-'
            }),
            new ColumnConfig<Sample>({
                name: 'IhLabResults.TWA',
                displayName: 'Time Weighted Average',
                cellTemplate: (sample) => {
                    if (!sample.ihLabResults?.length) return ' - ';
                    return sample.ihLabResults
                        .map(result => `<div>${this.getTWA(sample, result)}</div>`)
                        .join('');
                },
                cssClass: (sample) => sample.ihLabResults?.length ? 'cursor-pointer multiple-data-border' : 'cursor-pointer',
                applyNestedFiltering: true
            }),
            buildLabResultsColumn('IhLabResults.AgentId', 'Agent Name',
                (_, result) => result?.agentName, 'longer-data'),
            buildLabResultsColumn('IhLabResults.Id', 'Lab ID',
                (_, result) => result?.labId, 'longer-data'),
            buildLabResultsColumn('IhLabResults.OEL', 'OEL',
                (_, result) => result?.oel != null
                    ? `${this.valueConversionService.getParameterValueAsPerAgentUnit(result.oel, result.agentUnits).toFixed(4)} ${this.valueConversionService.getParameterUnitSymbol(result.agentUnits)}`
                    : '-'),
            buildLabResultsColumn('IhLabResults.OELTypeId', 'OEL Type',
                (_, result) => result?.oelTypeName),
            buildLabResultsColumn('IhLabResults.JurisdictionId', 'Jurisdiction',
                (_, result) => result?.jurisdictionName),
            buildLabResultsColumn('IhLabResults.AgentGroupId', 'Agent Group',
                (_, result) => result?.agentGroupName),
            buildLabResultsColumn('IhLabResults.ConcValue', 'Conc Value',
                (_, result) => result?.concValue != null
                    ? `${this.valueConversionService.getParameterValueAsPerAgentUnit(result.concValue, result.agentUnits).toFixed(4)} ${this.valueConversionService.getParameterUnitSymbol(result.agentUnits)}`
                    : '-'),
            buildLabResultsColumn('IhLabResults.TotalMass', 'Total Mass',
                (_, result) => {
                    if (result?.totalMass == null) return '-';
                    const massValue = result.agentUnits === Units.MgPerM3
                        ? this.valueConversionService.convertUgPerM3ToMgPerM3(result.totalMass)
                        : result.totalMass;
                    const massUnit = result.agentUnits === Units.MgPerM3 ? 'mg' : 'µg';
                    return `${massValue.toFixed(4)} ${massUnit}`;
                }),
            buildLabResultsColumn('IhLabResults.SampleCensor', 'Sample Censor',
                (_, result) => SampleCensorSign[result.sampleCensor] || ' - '),
            buildLabResultsColumn('IhLabResults.DosePercentage', 'Dose Percentage',
                (_, result) => result?.dosePercentage != null ? `${result.dosePercentage}` : '-'),
            buildLabResultsColumn('IhLabResults.CorrectedDosePercent', 'Shift Adjusted Dose %',
                (_, result) => result?.correctedDosePercent != null ? `${result.correctedDosePercent.toFixed(1)}` : '-'),
            buildLabResultsColumn('IhLabResults.Poel', 'POEL',
                (_, result) => result?.sampleCensor === SampleCensorType.LessThan ? this.translateService.getDynamicTranslation('< LOQ') :
                    (result?.poel != null ? `${result.poel.toFixed(2)}%` : '-')),
            new ColumnConfig<Sample>({
                name: 'IhLabResults.AgentUnits',
                displayName: 'Agent Units',
                cellTemplate: (sample) => {
                    if (!sample.ihLabResults?.length) return ' - ';
                    return sample.ihLabResults.map(result =>
                        `<div>${result?.agentUnits != null ? UnitSymbols[result?.agentUnits] : '-'}</div>`
                    ).join('');
                },
                cssClass: (sample) => sample.ihLabResults?.length ? 'multiple-data-border' : '',
                applyNestedFiltering: true,
                hiddenFromFilter: true,
                enumFilterMap: ALL_UNITS_ENUM_FILTER_MAP
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.samplePreCal),
                displayName: 'Flow Rate Start',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => {
                    if (!sample.samplePreCal) return '-';
                    if (sample.sampleType === SampleTypeEnum.Noise) {
                        return `${sample.samplePreCal} dB`;
                    }
                    const value = this.valueConversionService.getParameterValueFromUserPreferences(sample.samplePreCal, ParameterTypeEnum.FlowRate);
                    const unit = this.parameterUnitService.getFlowRateUnit();
                    return `${value} ${unit}`;
                }
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.samplePostCal),
                displayName: 'Flow Rate End',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => {
                    if (!sample.samplePostCal) return '-';
                    if (sample.sampleType === SampleTypeEnum.Noise) {
                        return `${sample.samplePostCal} dB`;
                    }
                    const value = this.valueConversionService.getParameterValueFromUserPreferences(sample.samplePostCal, ParameterTypeEnum.FlowRate);
                    const unit = this.parameterUnitService.getFlowRateUnit();
                    return `${value} ${unit}`;
                }
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.sampleAverageCal),
                displayName: 'Average Flow Rate',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => {
                    if (!sample.sampleAverageCal) return '-';
                    if (sample.sampleType === SampleTypeEnum.Noise) {
                        return `${sample.sampleAverageCal} dB`;
                    }
                    const value = this.valueConversionService.getParameterValueFromUserPreferences(sample.sampleAverageCal, ParameterTypeEnum.FlowRate);
                    const unit = this.parameterUnitService.getFlowRateUnit();
                    return `${value} ${unit}`;
                }
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.sampleVolume),
                displayName: 'Sample Volume',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => {
                    if (!sample.sampleVolume) return '-';
                    const valueInLiters = this.valueConversionService.convertMlPerMinToLPerMin(sample.sampleVolume);
                    return `${valueInLiters.toFixed(4)} L`;
                }
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.correctedVolume),
                displayName: 'Corrected Volume',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => {
                    if (!sample.correctedVolume) return '-';
                    const valueInLiters = this.valueConversionService.convertMlPerMinToLPerMin(sample.correctedVolume);
                    return `${valueInLiters.toFixed(4)} L`;
                }
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.analyticalMethodId),
                displayName: 'Analytical Method',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => sample.analyticalMethodName
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.samplingEquipmentModelNumber),
                displayName: 'Sampling Equipment Model',
                cssClass: () => 'cursor-pointer',
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.samplingEquipmentSerialNumber),
                displayName: 'Sampling Equipment Serial',
                cssClass: () => 'cursor-pointer',
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.sampleMediaId),
                displayName: 'Sample Media',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => sample.sampleMediaName
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.sampledByUserId),
                displayName: 'Sampled By',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => sample.sampledByUsername
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.managingHygienistId),
                displayName: 'Managing Hygienist',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => sample.managingHygienistUserName
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.isOutlier),
                displayName: 'Is Outlier',
                cssClass: () => 'cursor-pointer',
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.outlierReason),
                displayName: 'Outlier Reason',
                cssClass: () => 'cursor-pointer',
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.exposureTypicality),
                displayName: 'Exposure Typicality',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => translateEnum(ExposureTypicality, sample.exposureTypicality, this.translateService),
                enumFilterMap: this.enumToValueNameArray(ExposureTypicality)
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.unsampledTimeCorrection),
                displayName: 'Unsampled Time Correction',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => translateEnum(UnsampledTimeCorrectionType, sample.unsampledTimeCorrection, this.translateService),
                enumFilterMap: this.enumToValueNameArray(UnsampledTimeCorrectionType)
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.blankSampleNumber),
                displayName: 'Blank Sample Number',
                cssClass: () => 'cursor-pointer',
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.temperatureMinC),
                displayName: 'Temperature Min',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => getTemp(sample?.temperatureMinC)
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.temperatureMaxC),
                displayName: 'Temperature Max',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => getTemp(sample?.temperatureMaxC)
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.humidityPercent),
                displayName: 'Humidity',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => sample?.humidityPercent != null ? (sample.humidityPercent + '%') : '-'
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.pressureMmhg),
                displayName: 'Pressure (mmHg)',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => sample?.pressureMmhg != null ? (sample.pressureMmhg + ' mmHg') : '-'
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.weatherCondition),
                displayName: 'Weather Condition',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => translateEnum(WeatherConditionType, sample.weatherCondition, this.translateService),
                enumFilterMap: this.enumToValueNameArray(WeatherConditionType)
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.dateCreated),
                displayName: 'Date Created',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => this.dateFormatService.formatDateTimeToString(
                    sample.dateCreated as Date, this.dateFormat)
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.updatedByUserId),
                displayName: 'Updated By User Id',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => sample.updatedByUserId || ' - '
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.dateUpdated),
                displayName: 'Date Updated',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => sample.dateUpdated ? this.dateFormatService.formatDateTimeToString(
                    sample.dateUpdated as Date, this.dateFormat) : '-'
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.voidReason),
                displayName: 'Void Reason',
                cssClass: () => 'cursor-pointer',
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.approvedByUserName),
                displayName: 'Approved By',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => sample.approvedByUserName ?? '-'
            }),
            new ColumnConfig<Sample>({
                name: nameOf<Sample>(x => x.approvedDate),
                displayName: 'Approved On',
                cssClass: () => 'cursor-pointer',
                cellTemplate: (sample) => sample.approvedDate ? this.dateFormatService.formatDateTimeToString(
                    sample.approvedDate as Date, this.dateFormat) : '-'
            }),
            { name: 'action', displayName: 'Action' }
        ];
    }

    override async getColumnDetailsAsync(): Promise<{ [property: string]: ColumnDetails }> {
        const details = await super.getColumnDetailsAsync();
        this.appendEndPointColumns(details);
        return details;
    }

    private appendEndPointColumns(details: { [property: string]: ColumnDetails }): void {
        const existing = new Set(this.columnConfigs.map(column => column.name));
        const endPointColumns = Object.keys(details)
            .filter(key => isSampleEndPointColumn(key) && !existing.has(key))
            .map(key => {
                details[key] = { ...details[key], type: toEndPointColumnType(details[key].dataType) };
                return buildSampleEndPointColumn(key, details[key]);
            });
        if (!endPointColumns.length) return;

        const actionIndex = this.columnConfigs.findIndex(column => column.name === 'action');
        const insertAt = actionIndex === -1 ? this.columnConfigs.length : actionIndex;
        this.columnConfigs = [
            ...this.columnConfigs.slice(0, insertAt),
            ...endPointColumns,
            ...this.columnConfigs.slice(insertAt),
        ];
    }

    override objectFilterMap(propertyName: string): ICrudService<unknown> | undefined {
        switch (propertyName) {
            case nameOf<Sample>(x => x.segId): return this.segService;
            case nameOf<Sample>(x => x.organizationLevelId): return this.organizationLevelService;
            case 'IhLabResults.AgentId': return this.agentService;
            case 'IhLabResults.Id': return this.ihLabResultService;
            case 'IhLabResults.OELTypeId': return this.oelTypeService;
            case 'IhLabResults.JurisdictionId': return this.jurisdictionService;
            case 'IhLabResults.AgentGroupId': return this.agentGroupService;
            case 'IhLabResults.SampleMediaId': return this.sampleMediaService;
            case 'IhLabResults.AnalyticalMethodId': return this.analyticalMethodService;
            case nameOf<Sample>(x => x.sampleSurveyId): return this.sampleSurveyService;
            default: return undefined;
        }
    }

    override initializeOverviewConfigs(): void {
        this.overviewConfigs = [];
    }

    override initializeTabs() {
        return sampleRouteConfig;
    }

    override initializeProperties(): void {
        this.addEntityTitle = 'Samples';
        this.searchPlaceholder = 'Search Samples';
        this.selectedItemsLabel = 'sample';
        const canEdit = this.hasPermission(this.GridPermissions.Update);
        this.batchActions = [
            {
                label: 'Change Status',
                matIcon: 'sync_alt',
                disabled: true,
                menuItems: this.buildStatusMenuItems()
            },
            {
                label: 'Edit',
                matIcon: 'edit',
                disabled: true,
                // Bulk edit is under validation; hide until testing is complete
                // hidden: !canEdit,
                hidden: true,
                onClick: () => this.openBatchEdit()
            },
            {
                label: 'Delete',
                matIcon: 'delete',
                class: 'batch-action-danger',
                disabled: true,
                onClick: () => this.openBulkDeleteDialog()
            }
        ] as BatchAction[];

        this.evidencePackExportOption = {
            label: 'Export evidence pack',
            onClick: () => this.openEvidencePackDialog()
        };
        this.extraExportOptions = [this.evidencePackExportOption];
    }

    private evidencePackExportOption?: ExportMenuOption;

    private static readonly EVIDENCE_PACK_COMPONENTS: ReadonlyArray<{
        flag: keyof EvidencePackComponentFlags;
        label: string;
        requiresPii: boolean;
    }> = [
        { flag: 'includeChainOfCustody', label: 'Chain of custody', requiresPii: true },
        { flag: 'includeLabCertificates', label: 'Lab certificates', requiresPii: false },
        { flag: 'includeLetters', label: 'Letters', requiresPii: true },
        { flag: 'includeFieldSheets', label: 'Field sheets', requiresPii: true },
        { flag: 'includeCalibrationRecords', label: 'Calibration records', requiresPii: false },
        { flag: 'includeChangeHistory', label: 'Change history', requiresPii: true }
    ];

    private buildEvidencePackComponentOptions(): EvidencePackComponentOption[] {
        const canViewPii = this.permissionService.hasPermissionFlag(
            RolePermissionObjects.Pii,
            PermissionFlags.ReadMy | PermissionFlags.ReadHierarchy
        );
        return SampleListComponent.EVIDENCE_PACK_COMPONENTS.map(component => {
            const disabled = component.requiresPii && !canViewPii;
            return {
                flag: component.flag,
                label: component.label,
                checked: !disabled,
                disabled,
                disabledReason: disabled ? 'Requires View PII permission' : undefined
            };
        });
    }

    private openEvidencePackDialog(): void {
        const dialogRef = this.dialog.open(EvidencePackDialogComponent, {
            width: '420px',
            data: { components: this.buildEvidencePackComponentOptions() }
        });
        const sub = dialogRef.afterClosed().subscribe((flags?: EvidencePackComponentFlags) => {
            if (flags) {
                this.runEvidencePackExport(flags);
            }
        });
        this.multiSamplePopupSubs.push(sub);
    }

    private runEvidencePackExport(flags: EvidencePackComponentFlags): void {
        if (this.evidencePackExportOption) {
            this.evidencePackExportOption.disabled = true;
        }
        this.toastService.showInfo('Preparing evidence pack...', true);

        const selectedIds = (this.selectionService?.selectedItems ?? []).map(sample => sample.id);
        const request: EvidencePackRequest = {
            ...this.buildExportScope(),
            ids: selectedIds.length > 0 ? selectedIds : undefined,
            ...flags
        };

        const sub = this.sampleService.exportEvidencePack(request).subscribe({
            next: (response) => {
                this.saveBlobResponse(response, 'evidence-pack.zip');
                if (this.evidencePackExportOption) {
                    this.evidencePackExportOption.disabled = false;
                }
            },
            error: (err: HttpErrorResponse) => {
                if (this.evidencePackExportOption) {
                    this.evidencePackExportOption.disabled = false;
                }
                void this.handleEvidencePackError(err);
            }
        });
        this.multiSamplePopupSubs.push(sub);
    }

    private async handleEvidencePackError(err: HttpErrorResponse): Promise<void> {
        if (err.status === 429) {
            this.toastService.displayErrorMessage('A render is already in progress.', true);
            return;
        }

        let message = this.translateService.getDynamicTranslation('Export failed');
        const body = err.error;
        if (body instanceof Blob) {
            try {
                // The BE writes error bodies as plain text — ExceptionHandler.HandleException
                // calls Response.WriteAsync(exception.Message) with no JSON envelope. So the
                // blob body already IS the (localized) message; read it directly, don't JSON.parse.
                // Still sanitize before it reaches the [innerHTML] toast.
                const raw = (await body.text()).trim();
                if (raw) {
                    message = this.sanitizer.sanitize(SecurityContext.HTML, raw) ?? message;
                }
            } catch {
                // Unreadable error body — fall back to the default message.
            }
        } else if (typeof body?.message === 'string') {
            // Sanitize server-supplied text before it reaches the [innerHTML] toast.
            message = this.sanitizer.sanitize(SecurityContext.HTML, body.message) ?? message;
        }
        // Note: the raw-string-body path is intentionally omitted — verbose server text
        // can leak internals and carries HTML-injection risk in the enableHtml toast.

        this.toastService.displayErrorMessage(message);
    }

    override getOverviewData(): Observable<void> {
        return of(undefined);
    }

    override openEntityDialog(sampleId?: string): void {
        const sampleModel: IFormDialogData = { id: sampleId, columnDetails: this.columnDetails };
        this.openFlyoutInternal(SampleDialogComponent, sampleModel, '90vw');
        this.eventService.broadcast(EventKeys.blockOutsideCLick, true);
    }

    override openEntityDeleteDialog(sample: Sample): void {
        this.openDeleteDialog(DeleteDialog, sample, this.sampleService, 'Sample', undefined, undefined, () => this.removeRow(sample.id));
    }

    onFlyoutClose() {
        this.loadPage();
    }

    /** Build Change Status menu items, filtered by selected samples' types when available. */
    private buildStatusMenuItems(samples?: Sample[]): BatchActionMenuItem<number>[] {
        const allStatuses = getEnumLookup(SampleStatusEnum);
        let filtered: { id: number; name: string }[];

        if (samples?.length) {
            const types = new Set(samples.map(s => s.sampleType as number));
            const categories = new Set(samples.map(s => s.sampleCategory as number));
            const sampleType = types.size === 1 ? [...types][0] : null;
            const sampleCategory = categories.size === 1 ? [...categories][0] : null;
            filtered = getFilteredSampleStatuses(allStatuses, sampleType, sampleCategory);
        } else {
            filtered = allStatuses.filter(s => s.id !== SampleStatusEnum.Planned);
        }

        return filtered.map(s => ({
            label: s.name,
            value: s.id,
            color: SampleStatusColors[s.id as SampleStatusEnum],
            textColor: SampleStatusTextColors[s.id as SampleStatusEnum],
            disabled: true,
            onClick: (value: number) => this.bulkUpdateStatus(value)
        }));
    }

    bulkUpdateStatus(newStatus: number): void {
        const selected = this.selectionService!.selectedItems;
        if (!selected.length) return;

        const invalidTransitions: string[] = [];
        const validSamples: Sample[] = [];

        for (const sample of selected) {
            if (!isSampleStatusSelectable(sample.sampleStatus, newStatus as SampleStatusEnum)) {
                invalidTransitions.push(sample.sampleNumber || `Sample #${sample.id}`);
                continue;
            }
            validSamples.push(sample);
        }

        if (invalidTransitions.length) {
            this.toastService.displayErrorMessage(
                this.translateService.getDynamicTranslation(
                    'Invalid Transition for: {{samples}}',
                    { samples: invalidTransitions.join(', ') }
                )
            );
        }

        if (!validSamples.length) return;

        if (newStatus === SampleStatusEnum.Void) {
            const dialogRef = this.dialog.open(VoidReasonDialogComponent, {
                data: { voidReason: '' },
                width: '400px',
            });
            this.multiSamplePopupSubs.push(
                dialogRef.afterClosed().subscribe((result: string | IVoidReasonResult) => {
                    const voidReason = typeof result === 'string'
                        ? result
                        : result?.confirmed
                            ? (result.voidReason || '')
                            : '';
                    if (voidReason) {
                        this.performBulkStatusUpdate(validSamples, newStatus, voidReason);
                    }
                })
            );
        } else if (isLockedSampleStatus(newStatus)) {
            this.confirmCalDriftThenUpdate(validSamples, newStatus);
        } else {
            this.performBulkStatusUpdate(validSamples, newStatus);
        }
    }

    // Locking is one-way, so samples over their cal drift limit are listed for review before anything is saved.
    // If the rules cannot be loaded the move goes ahead unchecked, as the single-sample dialog does.
    private confirmCalDriftThenUpdate(samples: Sample[], newStatus: SampleStatusEnum): void {
        this.multiSamplePopupSubs.push(
            this.tenantRiskService.getCurrent().pipe(
                map(tenantRisk => findCalDriftBreaches(samples, newStatus, tenantRisk?.sampleValidationConfig)),
                catchError(() => of<CalDriftBreach[]>([])),
                switchMap(breaches => breaches.length
                    ? this.dialog.open<BulkCalDriftWarningDialogComponent, IBulkCalDriftWarningData, boolean>(BulkCalDriftWarningDialogComponent, {
                        data: { breaches },
                        width: '560px',
                    }).afterClosed().pipe(map(confirmed => confirmed === true))
                    : of(true))
            ).subscribe({
                next: (confirmed) => {
                    if (confirmed) {
                        this.performBulkStatusUpdate(samples, newStatus);
                    }
                }
            })
        );
    }

    private performBulkStatusUpdate(samples: Sample[], newStatus: SampleStatusEnum, voidReason?: string): void {
        const sampleIds = samples.map(s => s.id);
        this.sampleService.bulkUpdateSampleStatus(sampleIds, newStatus, voidReason).subscribe({
            next: (response) => {
                if (response.successCount > 0) {
                    this.toastService.showSuccess(`{{count}} sample(s) status updated successfully`, true, { count: response.successCount });
                }
                if (response.failureCount > 0) {
                    const failedResults = response.result?.filter(r => !r.success) ?? [];
                    if (failedResults.length) {
                        const errorMessages = failedResults
                            .map(r => {
                                const sample = samples.find(s => s.id === r.sampleId);
                                const label = escapeHtml(sample?.sampleNumber || `Sample #${r.sampleId}`);
                                return r.error ? `${label}: ${escapeHtml(r.error)}` : label;
                            });
                        this.toastService.displayErrorMessage(errorMessages.join('<br>'));
                    } else {
                        this.toastService.displayErrorMessage(
                            this.translateService.getDynamicTranslation('Failed to update {{count}} sample(s)', { count: response.failureCount })
                        );
                    }
                }
                this.selectionService!.clear();
                this.onSelectionChanged();
                this.loadPage();
            },
            error: (error) => {
                this.toastService.showError(error);
            }
        });
    }

    openBatchEdit(): void {
        const selected = this.selectionService!.selectedItems;
        if (!selected.length) return;

        const dialogRef = this.dialog.open(BulkEditSamplesDialogComponent, {
            width: '700px',
            maxHeight: '90vh',
            data: {
                sampleIds: selected.map(s => s.id),
                samples: selected.map(s => ({ ...s }))
            }
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.loadPage();
                this.selectionService!.clear();
                this.onSelectionChanged();
            }
        });
    }

    openBulkDeleteDialog(): void {
        const selected = this.selectionService!.selectedItems;
        if (!selected.length) return;

        const dialogRef = this.dialog.open(BulkDeleteConfirmationDialogComponent, {
            width: '500px',
            data: {
                items: selected,
                entityLabel: 'Sample',
                entityLabelPlural: 'Samples',
                displayProperty: 'sampleNumber',
                nameProperties: ['sampleNumber'],
            } as BulkDeleteDialogData<Sample>,
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (!confirmed) return;
            const ids = selected.map(s => s.id);
            forkJoin(ids.map(id => this.sampleService.delete(id).pipe(
                map(() => ({ success: true })),
                catchError(() => of({ success: false }))
            ))).subscribe(results => {
                const completed = results.filter(r => r.success).length;
                const failed = results.filter(r => !r.success).length;
                this.onBulkDeleteComplete(completed, failed);
            });
        });
    }

    private onBulkDeleteComplete(completed: number, failed: number): void {
        if (completed > 0) {
            this.toastService.showSuccess(`{{count}} sample(s) deleted successfully`, true, { count: completed });
        }
        if (failed > 0) {
            this.toastService.displayErrorMessage(this.translateService.getDynamicTranslation('Failed to delete {{count}} sample(s)', { count: failed }));
        }
        this.selectionService!.clear();
        this.onSelectionChanged();
        this.loadPage();
    }

    protected override onSelectionChanged(): void {
        const selected = this.selectionService!.selectedItems;
        const count = selected.length;
        this.selectedRowsCount = count;

        // Rebuild the Change Status menu items filtered by the selected samples' type/category
        const changeStatusAction = this.batchActions.find(a => a.label === 'Change Status');
        if (changeStatusAction) {
            changeStatusAction.menuItems = this.buildStatusMenuItems(count > 0 ? selected : undefined);
            changeStatusAction.disabled = count === 0;
            changeStatusAction.menuItems.forEach(m => m.disabled = count === 0);
        }

        const editAction = this.batchActions.find(a => a.label === 'Edit');
        if (editAction) {
            // Bulk edit is under validation; keep hidden until testing is complete
            // editAction.hidden = !this.hasPermission(this.GridPermissions.Update);
            editAction.hidden = true;
            editAction.disabled = count === 0;
        }

        // Delete and other actions: disabled when nothing selected
        this.batchActions.filter(a => a.label !== 'Change Status' && a.label !== 'Edit').forEach(a => {
            a.disabled = count === 0;
        });
        this.setAdditionalButton();
    }

    setAdditionalButton() {
        const selectedSamples = this.selectionService!.selectedItems;
        const reportLabel = this.translateService.getDynamicTranslation('Generate Report');
        this.additionalButtons = [
            {
                title: selectedSamples.length ? `${reportLabel} (${selectedSamples.length})` : reportLabel,
                readonly: selectedSamples.length === 0,
                onClick: () => this.openMultiSampleReportPopup()
            },
            {
                title: selectedSamples.length ? `Generate COC (${selectedSamples.length})` : 'Generate COC',
                readonly: selectedSamples.length === 0,
                onClick: () => {
                    const generateCocModel: IGenerateCocPopup = {
                        id: '', samples: this.selectionService!.selectedItems, isFromSamples: true
                    };
                    this.isCocPopup = true;
                    this.openFlyoutInternal(GenerateCocPopupComponent, generateCocModel, '80vw', true)
                }
            }
        ];
    }

    private async openMultiSampleReportPopup(): Promise<void> {
        const selectedSamples = this.selectionService!.selectedItems;
        if (!selectedSamples.length) return;

        const allowedSamples = selectedSamples.filter(s => SampleListComponent.REPORT_ALLOWED_STATUSES.includes(s.sampleStatus));
        const exemptedSamples = selectedSamples.filter(s => !SampleListComponent.REPORT_ALLOWED_STATUSES.includes(s.sampleStatus));

        if (!allowedSamples.length) {
            this.toastService.displayErrorMessage(
                this.translateService.getDynamicTranslation('No samples in Approved or Approved Letter Sent status. Report cannot be generated.')
            );
            return;
        }

        const orgLevels = await firstValueFrom(this.organizationLevelService.getAll()) as OrgLevelNode[];
        const lca = findLowestCommonAncestor(allowedSamples.map(s => s.organizationLevelId), orgLevels);

        this.multiSampleReportPopupRef?.destroy();
        this.multiSamplePopupSubs.forEach(s => s.unsubscribe());
        this.multiSamplePopupSubs = [];

        const ref = createComponent(ReportGenerationPopupComponent, {
            environmentInjector: this.environmentInjector
        });
        ref.setInput(nameOf<ReportGenerationPopupComponent>(c => c.entities), allowedSamples);
        if (exemptedSamples.length) {
            ref.setInput(nameOf<ReportGenerationPopupComponent>(c => c.exemptedSamples), exemptedSamples);
        }
        ref.setInput(nameOf<ReportGenerationPopupComponent>(c => c.organizationLevelSummary), lca);
        ref.setInput(nameOf<ReportGenerationPopupComponent>(c => c.isVisible), true);

        this.multiSamplePopupSubs.push(
            ref.instance.close.subscribe(() => {
                ref.destroy();
                this.multiSampleReportPopupRef = undefined;
            }),
            ref.instance.pdfGenerated.subscribe(async (event: PdfGeneratedData) => {
                await this.reportGenerationService.generateAndSaveReport(event, {
                    entityIds: allowedSamples.map(s => s.id),
                    entityType: ENTITY_TYPES.MULTI_SAMPLE,
                    organizationLevelId: lca.id,
                    organizationLevelName: lca.name,
                    metadataKey: RolePermissionObjects.Sample
                });
            })
        );

        this.appRef.attachView(ref.hostView);
        document.body.appendChild(ref.location.nativeElement);
        this.multiSampleReportPopupRef = ref;
    }

    get hasDateFilter() {
        return true;
    }

    openSampleDetail(item: Sample) {
        this.router.navigate([`/dashboard/sample-details/${item.id}`]);
    }

    openLabRequisition() {
        this.router.navigate([`/dashboard/samples/lab-requisition`]);
    }

    getTWA(sample: Sample, value: IhLabResult) {
        if (value?.twa == null) return '-';

        const displayValue = this.valueConversionService.getParameterValueAsPerAgentUnit(value.twa, value.agentUnits);
        const displayUnit = this.valueConversionService.getParameterUnitSymbol(value.agentUnits) ?? '';
        const data = `${displayValue.toFixed(4)} ${displayUnit}`;
        let sign = "";
        if (value.sampleCensor && value.sampleCensor != SampleCensorType.NA) {
            sign = SampleCensorSign[value.sampleCensor];
        }
        return sign + data;
    }

    getSampleStatusDisplayName(row: Sample): string {
        const key = (row.sampleType === SampleTypeEnum.Noise && row.sampleStatus === SampleStatusEnum.AwaitingLabSubmission)
            ? 'Awaiting Results'
            : (this.sampleStatusEnum[row.sampleStatus] ?? '-');
        return this.translateService.getDynamicTranslation(key);
    }

    getSampleStatusBadgeClass = getStatusBadgeClass;

    ngOnDestroy() {
        super.ngOnDestroy();
        this.eventService.unsubscribeAllEvents([EventKeys.flyoutClose, EventKeys.blockOutsideCLick]);
        this.multiSamplePopupSubs.forEach(s => s.unsubscribe());
        this.multiSampleReportPopupRef?.destroy();
    }
}
